// extracted by mini-css-extract-plugin
module.exports = {"overlay":"asideDrawer_overlay__Cdp4T","visible":"asideDrawer_visible__QTO10","asideContainer":"asideDrawer_asideContainer__7JILu"};